import * as React from 'react'
import styled from '../theme'

const Content = styled.h1`
    width: 100%;
    text-align: center;
    font-size: 5em;
    font-weight: 200;
    text-transform: uppercase;
    margin: 60px 0 30px 0;
    padding: 0;
    letter-spacing: -5px;
    color: ${(props: any) => props.theme.colors.bodyHighlight};

    @media (max-width: 550px) {
        font-size: 3.5em;
    }
`

const Title = (props: { content: string }) => (
    <Content>
        {props.content}
    </Content>
)

export default Title



// WEBPACK FOOTER //
// ./src/components/TitleComponent.tsx